import React from "react";
import logo from "../assets/logo.png"; // ✅ import โลโก้

const TopBar = () => {
  return (
    <div className="w-full bg-[#f9762f] text-white py-3 px-4 shadow flex items-center justify-center gap-2">
      <img src={logo} alt="Logo" className="h-8 w-8 object-contain" />
      <h1 className="text-lg font-bold">Super Pet Shop</h1>
    </div>
  );
};

export default TopBar;
